import { ErrorMiddleware, NextMiddleware, RequestError } from './protocol/base-http-service'
import { DialogStore, ERROR } from './stores/dialog-store'
import { getStore } from './stores/stores-repository'
import { goToRoute } from './utils/route-utils'

export function getGeneralErrorMiddleware(): ErrorMiddleware {
    return (error: RequestError, next: NextMiddleware) => {
        const dialogStore: DialogStore = getStore<DialogStore>(DialogStore.storeName)

        switch (error?.response?.status) {
            case 400: {
                dialogStore.showDialog({
                    title: 'Невалидные данные',
                    mode: ERROR,
                    message: `${error.name}: ${extractErrorMessageFromResponse(error)}`
                })
                break
            }
            case 404: {
                goToRoute('/404')
                break
            }
            case 500: {
                dialogStore.showDialog({
                    title: 'Ошибка сервера',
                    mode: ERROR,
                    message: `${error.name}: ${extractErrorMessageFromResponse(error)}`
                })
                break
            }
            default: {
                dialogStore.showDialog({
                    title: 'При запросе на сервер произошла ошибка',
                    mode: ERROR,
                    message: `${error.name}: ${extractErrorMessageFromResponse(error)}`
                })
            }
        }

        next()
    }
}

export function extractErrorMessageFromResponse (error: RequestError): string {
    if (error?.response?.data) {
        return JSON.stringify(error.response.data, null, 2)
    }

    return error.message
}
